import { FunctionComponent } from 'react'

const CircleFullSVG: FunctionComponent<{className?: string}> = (props) => {
	return (
<svg className={props.className ? props.className : ""} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	  viewBox="0 0 15 15"  xmlSpace="preserve">
<path d="M14,7.5c0,3.5899-2.9101,6.5-6.5,6.5S1,11.0899,1,7.5S3.9101,1,7.5,1S14,3.9101,14,7.5z"/>
</svg>
	)
}

export default CircleFullSVG
